// extracted by mini-css-extract-plugin
export var actions = "_1l-0";
export var actionsContainer = "_1l-6";
export var border = "_1l-1";
export var childFullHeight = "_1l-d";
export var collapse = "_1l-2";
export var content = "_1l-8";
export var contentChild = "_1l-c";
export var fullscreen = "_1l-a";
export var headerContainer = "_1l-3";
export var headerRow = "_1l-5";
export var hidePadding = "_1l-9";
export var noScrollX = "_1l-e";
export var noScrollY = "_1l-f";
export var optOutTopPadding = "_1l-b";
export var pagePadding = "_1l-7";
export var profile = "_1l-g";
export var profileContainer = "_1l-h";
export var profileImage = "_1l-i";
export var profileMain = "_1l-j";
export var profileSubtitle = "_1l-l";
export var profileTitle = "_1l-k";
export var tabsWrapper = "_1l-4";
export var title = "_1l-m";